import { AxiosResponse } from 'axios';
import { call, put, StrictEffect, takeLatest } from 'redux-saga/effects';
import apiRequests from 'src/utils/api';
import apiRoutes from 'src/utils/apiRoutes';
import {
  getContacts,
  setContactsData,
  setContactsError,
  setContactsLoading,
} from './reducer';
import { getCurrentCustomer } from 'src/utils/localStorage';

const { get } = apiRequests;

function* getContactsSagaListener({ payload }: any) {
  try {
    const customer = getCurrentCustomer();

    if (!customer) return;

    yield put(setContactsLoading());
    const res: AxiosResponse = yield call(get, apiRoutes.CONTACTS, {
      ...payload,
      'filters[billing_contacts.status][]': 'active',
      'filters[customer.uuid][]': customer.uuid,
      'page[size]': 500,
    });

    yield put(setContactsData(res.data));
  } catch (error) {
    yield put(setContactsError(error));
  }
}
function* contactsSaga(): Generator<StrictEffect> {
  yield takeLatest(getContacts.type, getContactsSagaListener);
}

export default contactsSaga;
